<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="dialogVisible"
    width="60%"
    @close="cancel"
  >
    <div class="userQuery">
      <div class="box-contain">
        <div class="info-box-label">方法名称：</div>
        <div class="info-box-value">{{ dataForm.MethodName }}</div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">异常信息：</div>
        <div class="info-box-value">
          {{ dataForm.ExceptionMsg }}
        </div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">异常来源：</div>
        <div class="info-box-value">
          {{ dataForm.ExceptionSource }}
        </div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">ClassName：</div>
        <div class="info-box-value">
          {{ dataForm.ClassName }}
        </div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">来源：</div>
        <div class="info-box-value">
          {{ dataForm.Source }}
        </div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">异常时间：</div>
        <div class="info-box-value">
          {{ (dataForm.ExceptionTime * 1000) | formatDate }}
        </div>
      </div>
      <div class="box-contain">
        <div class="info-box-label">StackTrace：</div>
        <div class="info-box-value">
          {{ dataForm.StackTrace }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { formatData } from "@/utils/index";
export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {
    OfDialog,
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    showMemberType(type) {
      return formatData(type, this.memberType);
    },
    showAccountType(type) {
      return formatData(type, this.accountType);
    },
    showRoleType(rowData) {
      let roleName = "";
      if (rowData) {
        let role = rowData.split(",");
        role.forEach((item) => {
          switch (item) {
            case "1":
              if (roleName == "") {
                roleName = "受赠者";
              } else {
                roleName = roleName + "，" + "受赠者";
              }
              break;
            case "2":
              if (roleName == "") {
                roleName = "捐赠者";
              } else {
                roleName = roleName + "，" + "捐赠者";
              }
              break;
            case "3":
              if (roleName == "") {
                roleName = "捐献者";
              } else {
                roleName = roleName + "，" + "捐献者";
              }
              break;
            case "4":
              if (roleName == "") {
                roleName = "救护者";
              } else {
                roleName = roleName + "，" + "救护者";
              }
              break;
          }
        });
      } else {
        roleName = "--";
      }
      return roleName;
    },
  },
};
</script>
<style lang="scss" scoped>
.userQuery {
  padding: 0.2rem;
  .box-contain {
    width: 100%;
    display: flex;
    height: auto;
    line-height: 40px;
    border-bottom: 1px dashed #e6e6e6;
    .info-box-label {
      flex: 0.15;
      color: #333;
      text-align: right;
    }
    .info-box-value {
      padding-left: 20px;
      flex: 0.85;
      color: #3c3c3c;
      text-align: left;
    }
  }
}
</style>

